
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exercises",
      function () {
        return require("private-next-pages/exercises/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exercises"])
      });
    }
  